import { defineStore } from 'pinia';
import { HelloResponse } from '../globals/ServerManager';
import serverFetch from '../globals/ServerFetch';

// eslint-disable-next-line import/prefer-default-export
export const useUserStore = defineStore({
	id: 'user',
	state: () => ({
		/** Identyfikator użytkownika. */
		userId: 0,
		/** Identyfikator wykonawcy. */
		customerId: 0,

		/** Czy użytkownik ma uprawnienia administratorskie? */
		isAdmin: false,
		/** Czy użytkownik jest wykonawcą? */
		isCustomer: false,
		/** Czy użytkownik jest wykonwacą Oferteo Express? */
		isExpressSpecialist: false,
		/** Czy użytkownik uczestniczy w programie partnerskim? */
		isPartner: false,
		/** Główna rola użytkownika */
		role: '',
		/** Lista wszystkich ról użytkownika */
		roles: [] as string[],
		/** Czy użytkownik zalogował się przy użyciu hasła (zamiast np. linku autowlogowującego)? */
		isAuth: false,

		/** Imię użytkownika */
		firstName: '',
		/** Nazwisko użytkownika */
		lastName: '',
		/** Nazwa firmy użytkownika */
		companyName: '',
		/** Numer telefonu użytkownika */
		phone: '',
		/** Adres email użytkownika */
		email: '',
		/** Miasto siedziby użytkownika */
		city: '',
		/** Obrazek profilowy użytkownika */
		avatar: '',
		/** Numer NIP użytkownika */
		nip: { country: 'PL', value: '', isIndividual: false },

		/** Adres wizytówki użytkownika */
		profileUrl: '',
		/** Płeć użytkownika */
		sex: 'MALE' as 'MALE' | 'FEMALE' | 'NEUTRAL',
		/** Zdobyte przez wykonawcę odznaki */
		badges: [] as string[],
		/** Adres strony Najlepsi na której znajduje się wykonawca */
		bestBadgeUrl: '',

		/** Procentowe wypełnienie profilu użytkownika. */
		profileCompletness: 0,
		/** Aktualny stan konta użytkownika. */
		accountBalance: 0,
		/** Maksymalna cena za odkrycie jednego zapytania w kategorii. */
		maxCategoryPrice: 0,
		/** Limit zwrotów */
		reversalLimit: 0,
		/** Informacja o postępie płatności w zewnętrznym serwisie. */
		paymentProgress: '' as '' | 'success' | 'fail',

		/** Adres email użytkownika przy przełączeniu konta. */
		loggedAs: '',

		/** flaga do prezentowania informacji debug np. w appce w postaci alertow na srodowisku tst */
		frontEndDebug: false,

		/** Flaga czy użytkownik dostanie testową zachętę do kontynuowania w aplikacji */
		abTestContinueInMobileApp: false,
	}),
	actions: {
		update(rsvp: HelloResponse) {
			const { user } = rsvp;
			if (!user) { return; }

			this.userId = user.idUser;
			this.customerId = user.idCustomer;

			this.isCustomer = user.idCustomer > 0;
			this.isAdmin = rsvp.role === 'ADMIN';
			this.isPartner = rsvp.role === 'ADMIN' || rsvp.role === 'CUSTOMER';
			this.isExpressSpecialist = rsvp.expressSpecialist || false;
			this.isPartner = user.isPartner || false;
			this.role = rsvp.role || '';
			this.roles = rsvp.allRoles || [];
			this.isAuth = user.isAuth || false;

			this.firstName = user.firstName || '';
			this.lastName = user.lastName || '';
			this.companyName = user.companyName || '';
			this.phone = user.phone || '';
			this.email = user.email || '';
			this.city = user.city || '';
			this.avatar = (user.avatar || '').indexOf('images/hero') > -1 ? '' : user.avatar || ''
			this.nip = user.nip || this.nip;

			this.profileUrl = user.profileUrl || '';
			this.sex = user.sex || 'MALE';
			this.badges = user.badges || [];
			this.bestBadgeUrl = user.bestUrl || '';

			this.profileCompletness = rsvp.profileCompletness || 0;
			this.accountBalance = rsvp.accountBalance || 0;
			this.maxCategoryPrice = rsvp.maxCategoryPrice || 0;
			this.reversalLimit = rsvp.reversalLimit || 0;
			this.paymentProgress = '';

			this.loggedAs = user.switchedToUsername || '';

			this.abTestContinueInMobileApp = user.abTestContinueInMobileApp || false;
		},

		/**
		 * Dodaje lub usuwa zdjęcie profilowe użytkownika,
		 * jeżeli zostało ono zmienione.
		 */
		async changeAvatar(avatarField: string) {
			// Jeżeli nic się nie zmieniło - nic nie rób.
			if (avatarField === this.avatar) {
				return '';
			}

			this.avatar = avatarField || '';

			// Jeżeli był obrazek, a go nie ma - usuń go.
			if (!avatarField) {
				await serverFetch('/myoferteo/konto-json/delete-avatar.ofer', {}, 'POST');
				return 'delete-avatar';
			}

			// W przeciwnym razie - dodaj obrazek.
			const filename = `${Number(new Date())}_avatar.jpg`;
			const bs = atob(avatarField.split(',')[1]);
			const ms = avatarField.split(',')[0].split(':')[1].split(';')[0];
			const ab = new ArrayBuffer(bs.length);
			const ia = new Uint8Array(ab);
			for (let i = 0; i < bs.length; i++) { ia[i] = bs.charCodeAt(i); }
			await serverFetch(
				'/myoferteo/konto-json/upload-avatar.ofer',
				{ file: new Blob([ab], { type: ms }), originalName: filename },
				'POST',
			);

			// Backend nie zwraca prawidłowej ścieżki po wysłaniu `upload-avatar.ofer`, dlatego też niezbędne jest pobranie obrazka z `hello.ofer`.
			serverFetch('/profile/hello.ofer').then((rsvp) => { this.avatar = rsvp.user.avatar; });
			return 'upload-avatar';
		},
	},
});
